import './About.css';

import AboutIntro from '../components/AboutIntro';
import Education from '../components/Education';
import Timeline from '../components/Timeline';
import Skills from '../components/Skills';
import Certificates from '../components/Certificates';

function About() {
  return (
    <div className="about-page">
      <AboutIntro />
      <Education />
      <Timeline />
      <Skills/>
      <Certificates />
    </div>
  );
}

export default About;
